import Auth from '../../auth'

// ルーターのナビゲーションガードからも同じインスタンスを使うので、モジュールで 1 つだけ作る。
// （vue-router 3 では router.app.$auth で引けたが、4 には router.app が無い）
export const auth = new Auth();

export default {
  install: function (app, options) {
    // Vue 2 の Vue.prototype.$auth に相当する
    app.config.globalProperties.$auth = auth;
  }
}
